import { IconDefinition } from '@ant-design/icons-angular';
export const BuildingIcon: IconDefinition = {
  name: 'building',
  theme: 'outline',
  icon: `
<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
  <path id="building" d="M2,1.5a.5.5,0,0,0-.5.5V14a.5.5,0,0,0,.5.5H4.5V12a1,1,0,0,1,1-1h1a1,1,0,0,1,1,1v2.5H10a.5.5,0,0,0,.5-.5V2a.5.5,0,0,0-.5-.5ZM0,2A2,2,0,0,1,2,0h8a2,2,0,0,1,2,2V14a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2ZM3,3.5A.5.5,0,0,1,3.5,3h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,3,4.5ZM7.5,3h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,4.5v-1A.5.5,0,0,1,7.5,3ZM3,7.5A.5.5,0,0,1,3.5,7h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,3,8.5ZM7.5,7h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5h-1A.5.5,0,0,1,7,8.5v-1A.5.5,0,0,1,7.5,7Z" fill="currentColor"/>
</svg>

  `,
};
